import React from 'react';
import PropTypes from 'prop-types';
import FilterItem from './FilterItem';
import ClearFilters from './ClearFilters';

/**
 * MobileAppliedFilters renders applied filters on mobile SRP.
 * Uses desktop-style chips: wrap layout, no counts, X to remove.
 */
const MobileAppliedFilters = ({ appliedFilters }) => {
	if (!appliedFilters || appliedFilters.length === 0) {
		return null;
	}

	return (
		<ul
			className="mobile-applied-filters list-unstyled d-flex flex-wrap align-items-center mb-3 d-lg-none"
			data-testid="mobile-applied-filters"
		>
			{appliedFilters.map((filter) =>
				filter.values.map((item) => (
					<li key={[filter.id, item.value].join('-')}>
						<FilterItem
							{...item}
							filterId={filter.id}
							filterLabel={filter.label}
							showRemoveButton={item.showRemoveButton}
						/>
					</li>
				))
			)}
			<li>
				<ClearFilters />
			</li>
		</ul>
	);
};

MobileAppliedFilters.propTypes = {
	appliedFilters: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			label: PropTypes.string,
			values: PropTypes.arrayOf(
				PropTypes.shape({
					label: PropTypes.string,
					value: PropTypes.string,
					showRemoveButton: PropTypes.bool
				})
			)
		})
	).isRequired
};

export default MobileAppliedFilters;
